/* eslint-disable react/prop-types */ // TODO: add props
import Keypad from './Keypad';
import KeypadButton from './KeypadButton';

const Operators = ({ onKeyPressWrite }) => (
  <Keypad className="operators" onKeyPressWrite={onKeyPressWrite}>
    <KeypadButton label="&times;" />
    <KeypadButton label="&divide;" />
    <KeypadButton label="-" />
    <KeypadButton label="+" />
    <KeypadButton label="=" />
  </Keypad>
);

export default Operators;
